import {environment} from '../../environments/environment';
import {ECardPurchaseType} from '../enums/ECardPurchaseType';

export class HomeConfigurations {
  contactEmail: string;
  urlIosStore: string;
  urlAndroidStore: string;
  footerDisclaimerEs: string;
  footerDisclaimerEn: string;
  maintenanceMode: boolean;
  maintenanceText: string;
  textFaqs: any;
  textFaqsWithoutCard: any;

  contractsData: any;

  pronounsOnboarding: boolean;
  pronounsWelcome: boolean;

  constructor() {
    this.urlAndroidStore = environment.androidStore;
    this.urlIosStore = environment.iosStore;
    this.maintenanceMode = false;
    this.maintenanceText = "";
    this.textFaqs = null;
    this.textFaqsWithoutCard = null;

    this.contractsData = null;

    this.pronounsOnboarding = false;
    this.pronounsWelcome = false;

  }
}

export class AccountConfiguration {
  cardPrice: number;
  statementsMaxDaysQueryPeriod: number;
  hasCardPurchase: boolean;
  hasCardLoads: boolean;
  hasStatements: boolean;
  hasCardBlocking: boolean;
  enablePinValidate: boolean;
  enablePinChange: boolean;
  enablePinReset: boolean;
  abaRoutingNumber: string;
  contactEmail: string;
  callCenterNumber: string;
  enableInternationalTransfers: boolean;
  enableInternalTransfers: boolean;
  enableAccountCancellation: boolean;
  enableGeolocation: boolean;
  enableFamilyHealth: boolean;
  enableSelfieDocuments: boolean;
  enableShowFaqsScreen: boolean;
  verificationProcessTime: string;
  maxGreendotCashLoads: string;
  minGreendotCashLoads: string;
  cardPurchaseType = ECardPurchaseType.DEFAULT;


  constructor() {
    this.hasCardLoads = false;
    this.hasStatements = false;
    this.enableInternationalTransfers = false;
    this.enableInternalTransfers = false;
    this.enableAccountCancellation = false;
    // * Card Options
    this.hasCardBlocking = false;
    this.hasCardPurchase = false;
    this.enablePinValidate = false;
    this.enablePinChange = false;
    this.enablePinReset = false;
    this.enableGeolocation = true; // Change to FALSE
    this.enableFamilyHealth = false;
    this.enableSelfieDocuments = false;
    this.enableShowFaqsScreen = false;
    // greendot Configurations
    this.maxGreendotCashLoads = '500';
    this.minGreendotCashLoads = '20';
  }

}

export class ApplicationConfiguration {
  instantIssue: boolean;
  validateCurp: boolean;
  brokerEnabled: boolean;
  enforceAgentLinkCorrectness: boolean;
  brokerEnabledInviteFriend: boolean;
  onboardingEnable: boolean;
  enablePrivacyAct: boolean;
  enablePhoneUsa: boolean;
  enablePhoneMex: boolean;
  enablePhoneGtm: boolean;
  enablePhoneEcu: boolean;
  enablePhoneSlv: boolean;
  enableSelfieRequiered: boolean;
  externalReferenceCodeMaxLength: number;
  maxTimeToWaitCardCreateInMillis: number;
  sendBrokerScreenToEnd: boolean;
  guatemalaDpiInputEnable: boolean;
  secondAddressLineEnable: boolean;

  constructor() {
    this.onboardingEnable = false;
    this.brokerEnabled = false;
    this.brokerEnabledInviteFriend = false;
    this.validateCurp = false;
    this.instantIssue = false;
    this.enablePrivacyAct = true;
    this.enablePhoneUsa = true;
    this.enablePhoneMex = true;
    this.enablePhoneGtm = true;
    this.enablePhoneEcu = true;
    this.enablePhoneSlv = true;
    this.enableSelfieRequiered = true;
    this.enforceAgentLinkCorrectness = false;

  }
}
